import SortableContainers from './SortableContainers.jsx';

const SortableList = ({ items, renderItem, onReorder, containerClassName }) => {
    return (
        <SortableContainers
            items={{ 0: items }}
            setItems={newItems => onReorder(newItems[0])}
            renderItem={renderItem}
            Container={({ children }) => (
                <div className={containerClassName}>{children}</div>
            )}
        />
    );
};

export default SortableList;
